import { useState, useCallback, useEffect } from "react";
import { FormStep } from "@/components/listings/filters/FilterSchema";

export const useFormState = () => {
  // Current step in the form
  const [currentStep, setCurrentStep] = useState<FormStep>(
    FormStep.PropertyInformation
  );

  // Form submission state
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Track completed steps
  const [completedSteps, setCompletedSteps] = useState<Record<number, boolean>>(
    {}
  );

  // Track if user can proceed to next step
  const [canProceedToNextStep, setCanProceedToNextStep] = useState(false);

  // Track if form has been touched (derived from currentStep)
  // If currentStep > 0, it means the user has interacted with the form
  const formTouched = currentStep > 0;

  // Track if validation should run on input change
  const [validateOnChange, setValidateOnChange] = useState(false);

  const setStepCompleted = useCallback(
    (step: FormStep, isCompleted: boolean) => {
      setCompletedSteps((prev) => ({
        ...prev,
        [step]: isCompleted,
      }));
    },
    []
  );

  // Define the total number of steps for the progress bar (0 to 6, so 7 steps)
  const TOTAL_WIZARD_STEPS = 7;

  // Calculate completion percentage based on current step
  // If currentStep is 0, progress is 1/7 * 100 (for the first step being "in progress")
  // If currentStep is 6 (the last step), progress is 7/7 * 100 = 100%
  const completionPercentage =
    TOTAL_WIZARD_STEPS > 0
      ? Math.min(((currentStep + 1) / TOTAL_WIZARD_STEPS) * 100, 100)
      : 0;

  return {
    currentStep,
    setCurrentStep,
    isSubmitting,
    setIsSubmitting,
    completedSteps,
    setStepCompleted,
    canProceedToNextStep,
    setCanProceedToNextStep,
    completionPercentage,
    formTouched,
    // setFormTouched is no longer needed as formTouched is derived
    validateOnChange,
    setValidateOnChange,
  };
};
